import api from "../../service/api"
import routes from "../../service/apiRoutes"

export const getGraph = (targetId) => api.get(routes.graph, { params: { target_id: targetId }, noauth: true })
